import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
  // viewBox="0 0 19 15"
  return (
    <>
      <path
        fill={color}
        d="M17.188 1.454h-2.393V1.04a1.042 1.042 0 0 0-2.081 0v.414H5.669V1.04a1.042 1.042 0 0 0-2.08 0v.414H1.194C.537 1.454 0 1.99 0 2.649v11.156C0 14.463.537 15 1.195 15h15.993c.658 0 1.195-.537 1.195-1.195V2.649c0-.658-.537-1.195-1.195-1.195Zm-3.771-.414c0-.185.152-.337.337-.337.186 0 .338.152.338.337v1.533a.338.338 0 0 1-.338.338.338.338 0 0 1-.337-.338V1.04Zm-9.126 0a.338.338 0 0 1 .675 0v1.533a.338.338 0 0 1-.337.338.338.338 0 0 1-.338-.338V1.04Zm13.386 12.768c0 .27-.222.492-.492.492H1.195a.495.495 0 0 1-.492-.492V5.88H17.68v7.928h-.003Zm0-8.63H.703V2.648c0-.27.222-.492.492-.492h2.393v.413c0 .574.467 1.04 1.04 1.04.574 0 1.041-.466 1.041-1.04v-.413h7.045v.413a1.042 1.042 0 0 0 2.08 0v-.413h2.394c.27 0 .492.222.492.492v2.528h-.003Z"
      />
    </>
  );
}
